import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Select from 'react-select'
import swal from 'sweetalert'
import {
	appAllGetTeams,
	appAllGetPermission,
	appCreateTeams,
	appUpdateTeams,
	appDeleteTeams,
} from '../../store/teams/index'
import { appGetAllUser } from '../../store/user'
import PostPreview from '../PostPreview/PostPreview'
import { teamExportColumns } from '../../config/exportColumns/teamExportColumns'
import ExportButton from '../../common/ExportButton'
import { designationOptions } from '../../common/jsonData'

function Management({ sansthaDetails, teamsList }) {
	//	console.log(teamsList)
	const params = useParams()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [page, setPage] = useState(params.page || 1)
	const [showModal, setShowModal] = useState(false)
	const [editMode, setEditMode] = useState(false)
	const [editData, setEditData] = useState(null)
	const [formData, setFormData] = useState({
		// firstName: "",
		// lastName: "",
		// email: "",
		mobile: '',
		designation: '',
	})
	const [selectedPermissions, setSelectedPermissions] = useState({})
	const [permissionError, setPermissionError] = useState('')
	const [isDurationEnabled, setIsDurationEnabled] = useState(false)
	const [duration, setDuration] = useState({ from: '', to: '' })
	const [designationError, setDesignationError] = useState('')
	const [durationError, setDurationError] = useState('')
	const [mobileError, setMobileError] = useState('')

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')
	//console.log(hubId, permissionOfHub)
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	const permissionList = useSelector(state => state.teamsReducer.permission)
	// const teamsList = useSelector((state) => state.teamsReducer.teams);
	const isdeleted = useSelector(state => state.teamsReducer.isdeleted)
	const users = useSelector(state => state?.usersReducer.users)

	const designationIndex = designationOptions.findIndex(opt => opt.value === formData.designation)

	useEffect(() => {
		dispatch(appAllGetPermission())
		dispatch(
			appGetAllUser({
				page: 1,
				limit: 1000,
				sansthaId: sansthaDetails._id || sansthaId || permissionOfSanstha,
			}),
		)
	}, [sansthaId || permissionOfSanstha])

	useEffect(() => {
		if (isdeleted) {
			dispatch(
				appAllGetTeams({
					page,
					limit: 10,
					sanstha: sansthaId || permissionOfSanstha,
				}),
			)
		}
	}, [isdeleted])

	const handlePermissionChange = (permissionId, label) => {
		const newPermissions = {
			...selectedPermissions,
			[permissionId]: !selectedPermissions[permissionId],
		}
		setSelectedPermissions(newPermissions)
		// Clear error if at least one permission is selected
		if (Object.values(newPermissions).some(value => value)) {
			setPermissionError('')
		}
	}

	const handleEdit = item => {
		//console.log(item)
		setEditMode(true)
		setEditData(item)

		// figure out where userId comes from
		const isHub = item?.userType === 'hub' || item?.hub
		const userId = isHub ? item?.userId?._id : item?._id

		setFormData({
			user: userId || '',
			mobile: item.mobile || (isHub ? item?.userId?.mobile : item?.mobile) || '',
			designation: item.designation || item?.joinedSanstha?.[0]?.designation || '',
		})

		// Set selected permissions
		const initialPermissions = {}
		const permissions = isHub ? item.permissions : item?.joinedSanstha?.[0]?.permissions || []
		//console.log(permissions)
		permissions.forEach(perm => {
			initialPermissions[perm._id] = true
		})
		setSelectedPermissions(initialPermissions)

		if (item.from && item.to) {
			setIsDurationEnabled(true)
			setDuration({
				from: item.from || '',
				to: item.to || '',
			})
		} else if (item?.joinedSanstha?.[0]?.from && item?.joinedSanstha?.[0]?.to) {
			setIsDurationEnabled(true)
			setDuration({
				from: item.joinedSanstha[0].from || '',
				to: item.joinedSanstha[0].to || '',
			})
		} else {
			setIsDurationEnabled(false)
			setDuration({ from: '', to: '' })
		}

		setShowModal(true)
	}

	const handleSubmit = e => {
		e.preventDefault()

		const selectedPerms = Object.entries(selectedPermissions)
			.filter(([_, isSelected]) => isSelected)
			.map(([id]) => id)

		const payload = {
			mobile: formData.mobile,
			permissions: [],
			designation: '',
			sort: 0,
			userType: 'sanstha',
			inactive: false,
			sanstha: sansthaId || permissionOfSanstha || sansthaDetails._id,
			// from: undefined,
			// to: undefined,
		}

		if (!/^\d{10}$/.test(formData.mobile)) {
			setMobileError('Mobile number must be exactly 10 digits.')
			return
		} else {
			setMobileError('')
		}

		// Case 1: Previous Committees
		if (isDurationEnabled) {
			if (!formData.designation) {
				setDesignationError('Required ')
				return
			}
			setDesignationError('')

			payload.designation = formData.designation
			payload.sort = designationIndex
			payload.permissions = []
			payload.from = duration.from
			payload.to = duration.to
			payload.inactive = true
			// payload.hub = hubId

			if (!duration.from || !duration.to) {
				setDurationError('Required')
				return
			}
			// setDurationError("");
		} else {
			if (selectedPerms.length === 0) {
				setPermissionError('Please select at least one permission.')
				return
			}
			setPermissionError('')

			payload.permissions = selectedPerms
			payload.designation = formData.designation
			payload.sort = designationIndex
			// payload.hub = hubId;
		}

		if (editMode) {
			dispatch(appUpdateTeams({ id: editData._id, ...payload })).then(() => {
				dispatch(
					appAllGetTeams({
						page,
						limit: 10,
						sanstha: sansthaId || permissionOfSanstha,
					}),
				)
			})
		} else {
			dispatch(appCreateTeams(payload))
				.then(() =>
					dispatch(
						appAllGetTeams({
							page,
							limit: 10,
							sanstha: sansthaId || permissionOfSanstha,
						}),
					),
				)
				.catch(err => {
					console.error('Create team error:', err)
				})
		}

		// Reset form
		setShowModal(false)
		setEditMode(false)
		setEditData(null)
		setFormData({
			// firstName: "",
			// lastName: "",
			// email: "",
			mobile: '',
			designation: '',
		})
		setSelectedPermissions({})
		setDuration({ from: '', to: '' })
		setPermissionError('')
		setDesignationError('')
	}

	const handleDeleteTeams = item => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this team?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				const payload = {
					_id: item?._id,
					mobile: item.mobile,
					designation: null,
					sort: null,
					userType: 'sanstha',
					inactive: false,
					sanstha: sansthaId || permissionOfSanstha,
					userId: null,
					permissions: [],
					from: null,
					to: null,
				}

				dispatch(appUpdateTeams(payload)).then(() => {
					dispatch(
						appAllGetTeams({
							page,
							limit: 10,
							sanstha: sansthaId || permissionOfSanstha,
						}),
					)
				})
			}
		})
	}

	return (
		<>
			<div className="mb-3 mr-2 d-flex justify-content-between align-items-center">
				<h4 className="ml-2"></h4>

				<div>
					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetTeams({
									...params,
									page,
									limit: 100000,
									sanstha: sansthaId || permissionOfSanstha,
									loading: false,
								}),
							)
						}
						columns={teamExportColumns}
						fileName="Management_Team"
						sheetName="Management"
						buttonText="Export Team"
					/>

					<button
						className="btn btn-primary ml-2"
						onClick={() => {
							setEditMode(false)
							setEditData(null)
							setFormData({
								firstName: '',
								lastName: '',
								email: '',
								mobile: '',
							})
							setSelectedPermissions({})
							setIsDurationEnabled(false)
							setDuration({ from: '', to: '' })
							setShowModal(true)
						}}
					>
						Add Team
					</button>
				</div>
			</div>

			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead>
						<tr>
							<th> Sr. No.</th>
							<th data-column-id="sender">Member</th>
							<th data-column-id="received" data-order="desc">
								Permission
							</th>
							<th data-column-id="received" data-order="desc">
								Previous Comittees
							</th>
							<th data-column-id="received" data-order="desc">
								Designation
							</th>
							<th data-column-id="received" data-order="desc">
								Duration
							</th>

							<th data-column-id="commands" data-formatter="commands" data-sortable="false">
								<div></div>
							</th>
						</tr>
					</thead>

					{teamsList?.length > 0 ? (
						<tbody>
							{teamsList.map((item, index) => (
								<tr key={item._id}>
									<td>{index + 1}</td>
									<td>
										<PostPreview value={item.profilePic || '/img/user.jpg'} />
										{item.firstName} {item.lastName}
										<br />
										<small>{item?.mobile}</small>
									</td>
									<td
										style={{
											maxWidth: '250px',
											wordWrap: 'break-word',
											whiteSpace: 'normal',
										}}
									>
										{item?.joinedSanstha[0].permissions?.map((place, i) => (
											<span key={i}>
												{place.label}
												{i < item?.joinedSanstha[0].permissions.length - 1 ? ', ' : ''}
											</span>
										))}
									</td>
									<td>
										{item?.joinedSanstha[0]?.inactive ? (
											<span className="badge badge-success">Previous Committees</span>
										) : null}
									</td>

									<td>{item?.joinedSanstha[0].designation}</td>
									<td>
										{item.joinedSanstha[0].from}-{item.joinedSanstha[0].to}
									</td>

									<td>
										<button
											type="button"
											className="btn btn-sm btn-info mr-2 command-edit"
											onClick={() => handleEdit(item)}
										>
											<em className="fa fa-edit fa-fw"></em>
										</button>
										<button
											type="button"
											className="btn btn-sm btn-danger command-delete"
											onClick={() => handleDeleteTeams(item)}
										>
											<em className="fa fa-trash fa-fw"></em>
										</button>
									</td>
								</tr>
							))}
						</tbody>
					) : (
						<tbody>
							<tr>
								<td colSpan="7" className="text-center">
									No Management data available
								</td>
							</tr>
						</tbody>
					)}
				</table>
			</div>

			{showModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">{editMode ? 'Edit Team' : 'Add New Team'}</h5>
								<button
									type="button"
									className="close"
									onClick={() => {
										setShowModal(false)
										setEditMode(false)
										setEditData(null)
										setFormData({
											firstName: '',
											lastName: '',
											email: '',
											mobile: '',
										})
										setSelectedPermissions({})
										setMobileError('')
									}}
								>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
								<form onSubmit={handleSubmit}>
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Select Users</label>
												<Select
													options={
														Array.isArray(users)
															? users.map(user => ({
																	value: user._id,
																	label: `${user?.firstName} ${user?.lastName} (${user?.mobile})`,
															  }))
															: []
													}
													onChange={option => {
														const selectedUser = Array.isArray(users)
															? users.find(u => u._id === option?.value)
															: null

														if (selectedUser) {
															setFormData(prev => ({
																...prev,
																user: selectedUser._id,
																mobile: selectedUser.mobile,
															}))
														}
													}}
													value={
														Array.isArray(users)
															? users.find(user => user._id === formData.user)
																? {
																		value: formData.user,
																		label: users.find(u => u._id === formData.user)?.firstName,
																  }
																: null
															: null
													}
													placeholder="Select User..."
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label>Designation </label>
												<Select
													options={designationOptions}
													value={designationOptions.find(opt => opt.value === formData.designation)}
													onChange={option => {
														setFormData(prev => ({
															...prev,
															designation: option.value,
														}))
														setDesignationError('')
													}}
													placeholder="Select Designation..."
													isSearchable
												/>
												{isDurationEnabled && designationError && (
													<div className="text-danger mt-2">{designationError}</div>
												)}
											</div>
										</div>
									</div>
									<div className="form-group">
										<label className="font-weight-bold mb-3">Permissions *</label>
										<div
											className="permissions-grid"
											style={{
												display: 'grid',
												gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
												gap: '10px',
												maxHeight: '200px',
												overflowY: 'auto',
												borderRadius: '4px',
											}}
										>
											{permissionList?.map(permission => (
												<div key={permission._id} className="custom-control custom-checkbox">
													<input
														type="checkbox"
														className="custom-control-input"
														id={`permission-${permission._id}`}
														checked={selectedPermissions[permission._id] || false}
														onChange={() =>
															handlePermissionChange(permission._id, permission.label)
														}
													/>
													<label
														className="custom-control-label"
														htmlFor={`permission-${permission._id}`}
														style={{
															cursor: 'pointer',
															padding: '2px 12px',
														}}
													>
														{permission.label}
													</label>
												</div>
											))}
										</div>
										{permissionError && <div className="text-danger mt-2">{permissionError}</div>}
									</div>
									<div className="form-group d-flex align-items-center">
										<label className="mr-3 mb-0" htmlFor="durationSwitch">
											Previous Comittes
										</label>
										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												id="durationSwitch"
												checked={isDurationEnabled}
												onChange={() => setIsDurationEnabled(prev => !prev)}
											/>
											<label className="custom-control-label" htmlFor="durationSwitch"></label>
										</div>
									</div>
									{isDurationEnabled && (
										<>
											{durationError && <div className="text-danger mt-2">{durationError}</div>}
											<div className="row">
												<div className="col-md-6">
													<div className="form-group">
														<label htmlFor="durationFrom">From (Year)</label>
														<input
															type="number"
															className="form-control"
															id="durationFrom"
															min="1900"
															max="2099"
															step="1"
															value={duration.from}
															onChange={e => {
																const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 4)
																setDuration(prev => ({
																	...prev,
																	from: val,
																}))
																setDurationError('')
															}}
														/>
													</div>
												</div>
												<div className="col-md-6">
													<div className="form-group">
														<label htmlFor="durationTo">To (Year)</label>
														<input
															type="number"
															className="form-control"
															id="durationTo"
															min="1900"
															max="2099"
															step="1"
															value={duration.to}
															onChange={e => {
																const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 4)
																setDuration(prev => ({
																	...prev,
																	to: val,
																}))
																setDurationError('')
															}}
														/>
													</div>
												</div>
											</div>
										</>
									)}
									<div className="modal-footer">
										<button className="btn btn-labeled btn-success" type="submit">
											<span className="btn-label">
												<i className="fa fa-check"></i>
											</span>
											{editMode ? 'Update' : 'Submit'}
										</button>
										<button
											className="btn btn-labeled btn-secondary ml-2"
											type="button"
											onClick={() => {
												setShowModal(false)
												setEditMode(false)
												setEditData(null)
												setFormData({
													firstName: '',
													lastName: '',
													email: '',
													mobile: '',
												})
												setSelectedPermissions({})
												setMobileError('')
											}}
										>
											<span className="btn-label">
												<i className="fa fa-times"></i>
											</span>
											Cancel
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}
export default Management
